// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Accessibility utilities */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Main content styles */
ion-content {
  padding: 0 10px;
  --background: #F3F3F3 !important;
}

/* Header toolbar */
.toolbar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px;
  background: white;
  align-items: center;
  box-shadow: 0px -4px 15px 0px rgba(79, 97, 79, 0.2509803922);
  /* Accessible button reset */
}
.toolbar .toolbar-button {
  background: transparent;
  border: none;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover styles */
  /* Active styles */
}
.toolbar .toolbar-button:focus {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.toolbar .toolbar-button:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.toolbar .toolbar-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.toolbar .toolbar-button:active {
  transform: scale(0.95);
}
.toolbar .toolbar-button ion-icon {
  font-size: 24px;
  color: var(--ion-color-secondary);
}
.toolbar .title {
  margin: 0;
  font-family: AppFontBold;
  font-size: 25px;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: center;
  color: #000;
}

/* Promo info banner */
.promo-info {
  align-items: center;
  padding: 15px;
  background: white;
  margin: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  font-size: 14px;
  /* Improve visibility on focus */
}
.promo-info .name {
  width: 180px;
}
.promo-info:focus-within {
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);
}

/* Minimum order notice */
.min-order {
  margin: 10px;
}

/* Add more button */
.add-more {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 34px;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding: 10px;
  cursor: pointer;
  border-radius: 22px;
  background-color: var(--ion-color-primary);
  border: none;
  margin-top: 15px;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
}
.add-more:focus {
  outline: 3px solid white;
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(113, 167, 97, 0.4);
}
.add-more:focus-visible {
  outline: 3px solid white;
  outline-offset: 2px;
}
.add-more:hover {
  background-color: var(--ion-color-primary-shade);
}
.add-more:active {
  transform: scale(0.98);
}
.add-more .add-text {
  font-family: AppFontBold;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0px;
  text-align: left;
  color: white;
}
.add-more .add-button {
  margin-right: 12px;
}

/* Empty cart presentation */
.card-actions {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* Disabled button state */
.footer-button.invalid, .footer-btn.invalid {
  --background: darkgrey;
  color: grey;
  cursor: not-allowed;
  opacity: 0.7;
}

/* Main container */
.wrapper {
  max-height: 100%;
  flex-direction: column;
  display: flex;
  height: 100%;
  background: #F3F3F3;
  background-size: cover;
}

/* Order list container */
.order-list {
  margin-block: 12px;
  width: 100%;
}

/* Article list presentation */
.article {
  text-align: center;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 992px) {
  .article {
    height: 35px;
  }
}

/* Ordered articles section */
.ordered-articles {
  flex: 1;
  overflow-y: auto;
  padding: 16px 17px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #F3F3F3;
  /* Improved scrollbar for accessibility */
  scrollbar-width: thin;
  scrollbar-color: var(--ion-color-primary) transparent;
}
.ordered-articles::-webkit-scrollbar {
  width: 8px;
}
.ordered-articles::-webkit-scrollbar-track {
  background: transparent;
}
.ordered-articles::-webkit-scrollbar-thumb {
  background-color: var(--ion-color-primary);
  border-radius: 4px;
}

.ordered-articles-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 13px;
}

/* Separator line */
.separator {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.separator .line {
  height: 8px;
  background-size: 7px 100%;
}
.separator--wide .line {
  background-size: 8px 100%;
}

/* Error messages */
.promo-error, .error-message {
  margin: 10px;
  font-size: 13px;
  text-align: center;
  color: #b02424;
  font-weight: bold;
}

/* Empty cart message */
.no-articles {
  display: flex;
  justify-content: center;
  padding: 20px;
}
.no-articles h3 {
  color: black;
  margin: 0;
}

/* Age verification checkbox */
.age-verified {
  color: var(--ion-color-primary);
  margin-bottom: 10px;
  background: #ffffff;
}
.age-verified ion-item {
  border: none;
  align-items: flex-start;
  /* Improve checkbox accessibility */
}
.age-verified ion-item ion-checkbox {
  --border-radius: 2px;
  --size: 20px;
}
.age-verified ion-item ion-checkbox:focus {
  --border-color: var(--ion-color-primary);
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);
}
.age-verified ion-item label {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  cursor: pointer;
  padding: 2px 0;
}

/* Recommendations section */
.recommenation_section {
  padding: 10px;
  margin: 10px 0;
  width: 100%;
  /* Recommendation item card */
}
@media (max-width: 992px) {
  .recommenation_section {
    padding: 10px 20px;
  }
}
@media (max-width: 400px) {
  .recommenation_section {
    padding: 10px;
    margin: 6px 0;
  }
}
.recommenation_section .recom_title {
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  margin-left: 10px;
}
.recommenation_section .recommenation_section_articles {
  width: 100%;
}
.recommenation_section .recommenation_section_articles__item {
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0px 1.95px 7.3px 0px rgba(79, 97, 79, 0.1490196078);
  background: white;
  width: 100%;
  text-align: left;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover styles */
  /* Active styles */
  /* Add button within recommendation */
}
.recommenation_section .recommenation_section_articles__item:focus {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}
.recommenation_section .recommenation_section_articles__item:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.recommenation_section .recommenation_section_articles__item:hover {
  transform: translateY(-2px);
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.15);
}
.recommenation_section .recommenation_section_articles__item:active {
  transform: translateY(1px);
}
.recommenation_section .recommenation_section_articles__item img {
  width: 120px;
  height: 60px;
  object-fit: contain;
  max-width: 200px;
  margin: 0 auto;
}
.recommenation_section .recommenation_section_articles__item .item-details {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.recommenation_section .recommenation_section_articles__item .item-details .left-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.recommenation_section .recommenation_section_articles__item .item-details .name {
  color: var(--ion-color-secondary);
  font-size: 13px;
  text-align: center;
  padding: 10px 5px;
  font-family: AppFontBold, sans-serif;
  margin-right: 5px;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 40px;
  margin: 0;
}
.recommenation_section .recommenation_section_articles__item .add_button {
  width: 100%;
  border: 1px solid var(--ion-color-secondary);
  background: transparent;
  padding: 8px;
  border-radius: 10px;
  color: var(--ion-color-secondary);
  font-family: AppFontBold;
  text-align: center;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  cursor: pointer;
  /* Focus styles */
  /* Hover styles */
  /* Active styles */
}
.recommenation_section .recommenation_section_articles__item .add_button:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
  background-color: rgba(0, 0, 0, 0.05);
}
.recommenation_section .recommenation_section_articles__item .add_button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.recommenation_section .recommenation_section_articles__item .add_button:active {
  background-color: rgba(0, 0, 0, 0.1);
}
.recommenation_section .recommenation_section_articles__item .price {
  text-align: right;
  padding: 5px 0;
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-secondary);
  margin: 0;
}

/* Swiper container styles */
swiper-container {
  height: 100%;
}
swiper-container swiper-slide {
  margin: 0 10px;
}

/* Footer section */
.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding: 17px;
  background: white;
  box-shadow: 0px -3px 45px 0px rgba(0, 0, 0, 0.1019607843);
  /* Price summary rows */
}
.footer .button-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  /* Total price row */
  /* Checkout button */
}
.footer .button-row .sub-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 19px;
}
.footer .button-row .sub-total .sub-total-title {
  font-family: AppFont;
  font-size: 14px;
  letter-spacing: 0em;
  text-align: left;
  color: var(--ion-color-secondary);
  margin: 0;
}
.footer .button-row .sub-total .sub-total-sum {
  font-family: AppFontBold;
  font-size: 14px;
  letter-spacing: 0em;
  text-align: right;
  color: var(--ion-color-secondary);
  margin: 0;
}
.footer .button-row .border-line {
  width: 100%;
  height: 3px;
  margin-top: 13px;
}
.footer .button-row .total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 19px;
}
.footer .button-row .total .total-title {
  font-family: AppFontBold;
  font-size: 18px;
  letter-spacing: 0em;
  text-align: left;
  color: var(--ion-color-secondary);
  margin: 0;
}
.footer .button-row .total .total-sum {
  font-family: AppFontBold;
  font-size: 18px;
  letter-spacing: 0em;
  text-align: right;
  color: var(--ion-color-secondary);
  margin: 0;
}
.footer .button-row .footer-btn {
  margin-top: 12px;
  min-height: 46px;
  height: 46px;
  width: 100%;
  position: relative;
  padding: 5px;
  background: var(--ion-color-primary);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
  /* Disabled state */
}
.footer .button-row .footer-btn:focus {
  outline: 3px solid var(--ion-color-primary-shade);
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(113, 167, 97, 0.25);
}
.footer .button-row .footer-btn:focus-visible {
  outline: 3px solid var(--ion-color-primary-shade);
  outline-offset: 2px;
}
.footer .button-row .footer-btn:hover:not(:disabled) {
  background-color: var(--ion-color-primary-shade);
}
.footer .button-row .footer-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.footer .button-row .footer-btn:disabled, .footer .button-row .footer-btn.invalid {
  background-color: #cccccc;
  cursor: not-allowed;
}
.footer .button-row .footer-btn:disabled .footer-btn-text, .footer .button-row .footer-btn.invalid .footer-btn-text {
  color: #777777;
}
.footer .button-row .footer-btn .footer-btn-text {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: center;
  color: #fff;
  margin: 0;
}

/* Promo code section */
.add-promo-section {
  padding: 10px 0;
  width: 100%;
  /* Promo button */
}
.add-promo-section .wrapper-promo {
  border: 1.5px solid var(--ion-color-primary);
  border-radius: 17px;
  overflow: hidden;
}
.add-promo-section .add-promo-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 20px;
  background: var(--ion-color-primary);
  color: white;
  padding: 10px;
  width: 100%;
  border: none;
  cursor: pointer;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
}
.add-promo-section .add-promo-block.border-bottom {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.add-promo-section .add-promo-block:focus {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: -2px;
  box-shadow: 0 0 0 4px rgba(113, 167, 97, 0.25);
}
.add-promo-section .add-promo-block:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: -2px;
}
.add-promo-section .add-promo-block:hover {
  background-color: var(--ion-color-primary-shade);
}
.add-promo-section .add-promo-block:active {
  background-color: var(--ion-color-primary-tint);
}
.add-promo-section .add-promo-block ion-img {
  width: 20%;
}
.add-promo-section .add-promo-block .block-text {
  width: 70%;
  padding: 10px;
  text-align: left;
}
.add-promo-section .add-promo-block .block-text h3 {
  font-family: AppFontBold, sans-serif;
  color: white;
  font-size: 20px;
  margin: 0 0 5px 0;
}
.add-promo-section .add-promo-block .block-text p {
  color: white;
  font-size: 18px;
  margin: 0;
}
.add-promo-section .add-promo-block .chevron {
  width: 22px;
  height: 22px;
}

/* Applied promocode display */
.add-promocode-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  border-radius: var(--custom-border-radius);
  box-shadow: 0px 0px 42px 0px rgba(0, 0, 0, 0.0705882353);
  padding: 10px 15px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  /* Promo code details */
  /* Remove promo button */
}
.add-promocode-wrapper ion-icon {
  width: 22px;
  height: 22px;
}
.add-promocode-wrapper .name-of-promo {
  display: flex;
  align-items: center;
  min-width: 60%;
  text-align: start;
  justify-content: space-between;
}
.add-promocode-wrapper .name-of-promo h2, .add-promocode-wrapper .name-of-promo h3 {
  font-size: 16px;
  color: var(--ion-color-secondary);
  font-family: AppFont, sans-serif;
  margin: 0;
}
.add-promocode-wrapper .name-of-promo h3 {
  font-family: AppFontBold, sans-serif;
}
.add-promocode-wrapper .edit_section {
  display: flex;
  align-items: center;
}
.add-promocode-wrapper .edit_section .bsg-remove-promo {
  background: transparent;
  border: none;
  padding: 8px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
}
.add-promocode-wrapper .edit_section .bsg-remove-promo:focus {
  border: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.add-promocode-wrapper .edit_section .bsg-remove-promo:focus-visible {
  border: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.add-promocode-wrapper .edit_section .bsg-remove-promo:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.add-promocode-wrapper .edit_section .bsg-remove-promo:active {
  transform: scale(0.95);
}
.add-promocode-wrapper .edit_section .bsg-remove-promo ion-icon {
  height: 30px;
  width: 30px;
  color: #b02424;
}

/* High contrast mode enhancements */
.bsg-high-contrast {
  /* Enhanced button focus */
  /* Enhanced toolbar */
  /* Enhanced footer */
  /* Enhanced promo section */
  /* Enhanced recommendation items */
  /* Add more button */
  /* Enhanced error message */
}
.bsg-high-contrast button:focus {
  outline: 3px solid #0078d7 !important;
  outline-offset: 2px !important;
}
.bsg-high-contrast .toolbar {
  border-bottom: 2px solid black;
  box-shadow: none;
}
.bsg-high-contrast .toolbar .toolbar-button ion-icon {
  color: black;
}
.bsg-high-contrast .toolbar .title {
  color: black;
}
.bsg-high-contrast .footer {
  border-top: 2px solid black;
  box-shadow: none;
}
.bsg-high-contrast .footer .sub-total-title, .bsg-high-contrast .footer .sub-total-sum, .bsg-high-contrast .footer .total-title, .bsg-high-contrast .footer .total-sum {
  color: black !important;
}
.bsg-high-contrast .footer .footer-btn {
  background: black;
  border: 2px solid white;
}
.bsg-high-contrast .footer .footer-btn:disabled, .bsg-high-contrast .footer .footer-btn.invalid {
  background: #555555;
  border: 2px dashed black;
}
.bsg-high-contrast .add-promo-block {
  background: black !important;
  border: 2px solid white;
}
.bsg-high-contrast .add-promo-block .block-text h3, .bsg-high-contrast .add-promo-block .block-text p {
  color: white !important;
}
.bsg-high-contrast .recommenation_section_articles__item {
  border: 2px solid black;
}
.bsg-high-contrast .recommenation_section_articles__item .name, .bsg-high-contrast .recommenation_section_articles__item .price {
  color: black !important;
}
.bsg-high-contrast .recommenation_section_articles__item .add_button {
  border: 2px solid black;
  color: black !important;
}
.bsg-high-contrast .add-more {
  background: black;
  border: 2px solid white;
}
.bsg-high-contrast .error-message {
  color: black !important;
  background: #ffcccc;
  border: 1px solid black;
  padding: 5px;
}

.visually-hidden {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.add-promo-section {
  padding: 10px 0;
  width: 100%;
  /* Enhanced Promo button with better focus visibility */
  /* Applied promo code section styling */
  /* Enhanced remove promo button */
  /* High contrast mode support */
  /* Mobile touch improvements */
}
.add-promo-section .wrapper-promo {
  border: 1.5px solid var(--ion-color-primary);
  border-radius: 17px;
  overflow: hidden;
  position: relative;
}
.add-promo-section .wrapper-promo:focus-within {
  box-shadow: 0 0 0 3px rgba(56, 128, 255, 0.3);
}
.add-promo-section .add-promo-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 16px;
  background: var(--ion-color-primary);
  color: white;
  padding: 10px;
  width: 100%;
  border: none;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  outline: none;
  /* ENHANCED FOCUS STYLES - Much more visible */
  /* Alternative high-contrast focus style */
  /* Hover state - make sure it's different from focus */
  /* Active state */
  /* Disabled state if needed */
}
.add-promo-section .add-promo-block.border-bottom {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.add-promo-section .add-promo-block:focus, .add-promo-section .add-promo-block:focus-visible {
  outline: 3px solid white !important;
  outline-offset: 2px !important;
  box-shadow: 0 0 0 6px var(--ion-color-primary-shade) !important;
  transform: scale(1.02);
  z-index: 10;
}
.add-promo-section .add-promo-block:focus-visible {
  box-shadow: inset 0 0 0 2px white, 0 0 0 4px var(--ion-color-warning, #ffc409), 0 4px 8px rgba(0, 0, 0, 0.2);
}
.add-promo-section .add-promo-block:hover:not(:focus) {
  background-color: var(--ion-color-primary-shade);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.add-promo-section .add-promo-block:active {
  background-color: var(--ion-color-primary-tint);
  transform: translateY(0);
  transition: all 0.1s ease;
}
.add-promo-section .add-promo-block:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}
.add-promo-section .add-promo-block:disabled:focus, .add-promo-section .add-promo-block:disabled:focus-visible {
  outline-color: var(--ion-color-medium);
  box-shadow: 0 0 0 3px rgba(150, 150, 150, 0.5);
}
.add-promo-section .add-promo-block ion-img {
  width: 20%;
  pointer-events: none;
}
.add-promo-section .add-promo-block .block-text {
  width: 70%;
  padding: 10px;
  text-align: left;
  pointer-events: none;
}
.add-promo-section .add-promo-block .block-text h3 {
  font-family: AppFontBold, sans-serif;
  color: white;
  font-size: 22px;
  margin: 0 0 5px 0;
  line-height: 1.2;
}
.add-promo-section .add-promo-block .block-text p {
  color: white;
  font-size: 18px;
  margin: 0;
  line-height: 1.3;
  opacity: 0.9;
}
.add-promo-section .add-promo-block .chevron {
  width: 22px;
  height: 22px;
  pointer-events: none;
  transition: transform 0.2s ease;
}
.add-promo-section .add-promo-block:focus .chevron, .add-promo-section .add-promo-block:focus-visible .chevron {
  transform: rotate(180deg);
}
.add-promo-section .add-promocode-wrapper {
  display: flex;
  align-items: center;
  padding: 12px;
  background: white;
  border-top: 1px solid rgba(var(--ion-color-primary-rgb), 0.2);
  gap: 12px;
}
.add-promo-section .add-promocode-wrapper .submit-button {
  width: 24px;
  height: 24px;
  color: var(--ion-color-success);
  flex-shrink: 0;
}
.add-promo-section .add-promocode-wrapper .name-of-promo {
  flex: 1;
}
.add-promo-section .add-promocode-wrapper .name-of-promo .name {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  color: var(--ion-color-secondary);
  margin: 0 0 2px 0;
  line-height: 1.2;
}
.add-promo-section .add-promocode-wrapper .name-of-promo .discount {
  font-family: AppFontBold, sans-serif;
  font-size: 13px;
  color: var(--ion-color-secondary);
  margin: 0;
  line-height: 1.2;
}
.add-promo-section .add-promocode-wrapper .edit_section {
  flex-shrink: 0;
}
.add-promo-section .edit-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  outline: none;
  /* ENHANCED FOCUS STYLES for remove button */
}
.add-promo-section .edit-btn:focus, .add-promo-section .edit-btn:focus-visible {
  outline: 2px solid var(--ion-color-danger) !important;
  outline-offset: 2px !important;
  background: rgba(var(--ion-color-danger-rgb), 0.1);
  box-shadow: 0 0 0 4px rgba(var(--ion-color-danger-rgb), 0.2);
  transform: scale(1.1);
}
.add-promo-section .edit-btn:hover:not(:focus) {
  background: rgba(var(--ion-color-danger-rgb), 0.1);
  transform: scale(1.05);
}
.add-promo-section .edit-btn:active {
  background: rgba(var(--ion-color-danger-rgb), 0.2);
  transform: scale(1);
}
.add-promo-section .edit-btn ion-icon {
  width: 20px;
  height: 20px;
  color: var(--ion-color-danger);
  pointer-events: none;
}
.add-promo-section .edit-btn:focus::after, .add-promo-section .edit-btn:focus-visible::after {
  content: "Remove promo code";
  position: absolute;
  top: -35px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--ion-color-dark);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 100;
  opacity: 1;
  animation: fadeIn 0.2s ease;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}
@media (prefers-contrast: high) {
  .add-promo-section .add-promo-block:focus, .add-promo-section .add-promo-block:focus-visible {
    outline: 4px solid yellow !important;
    outline-offset: 2px !important;
    box-shadow: 0 0 0 8px black, 0 0 0 12px yellow !important;
  }
  .add-promo-section .edit-btn:focus, .add-promo-section .edit-btn:focus-visible {
    outline: 3px solid red !important;
    background: yellow !important;
  }
  .add-promo-section .edit-btn:focus ion-icon, .add-promo-section .edit-btn:focus-visible ion-icon {
    color: red !important;
  }
}
@media (max-width: 768px) {
  .add-promo-section .add-promo-block {
    min-height: 48px;
  }
  .add-promo-section .add-promo-block:hover {
    transform: none;
  }
  .add-promo-section .edit-btn {
    min-width: 44px;
    min-height: 44px;
  }
  .add-promo-section .edit-btn:hover {
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-content/order-content.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA,4BAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AADF;;AAIA,wBAAA;AACA;EACE,eAAA;EACA,gCAAA;AADF;;AAIA,mBAAA;AACA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,4DAAA;EAEA,4BAAA;AAFF;AAGE;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EAEA,iBAAA;EAMA,0BAAA;EAMA,iBAAA;EAKA,kBAAA;AAhBJ;AAAI;EACE,2CAAA;EACA,mBAAA;AAEN;AAEI;EACE,2CAAA;EACA,mBAAA;AAAN;AAII;EACE,qCAAA;AAFN;AAMI;EACE,sBAAA;AAJN;AAOI;EACE,eAAA;EACA,iCAAA;AALN;AASE;EACE,SAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAPJ;;AAWA,sBAAA;AACA;EACE,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EAMA,gCAAA;AAbF;AASE;EACE,YAAA;AAPJ;AAWE;EACE,8CAAA;AATJ;;AAaA,yBAAA;AACA;EACE,YAAA;AAVF;;AAaA,oBAAA;AACA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;EAAA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,YAAA;EACA,gBAAA;EAEA,iBAAA;EAOA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;AA1BF;AASE;EACE,wBAAA;EACA,mBAAA;EACA,6CAAA;AAPJ;AAWE;EACE,wBAAA;EACA,mBAAA;AATJ;AAaE;EACE,gDAAA;AAXJ;AAeE;EACE,sBAAA;AAbJ;AAgBE;EACE,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAdJ;AAiBE;EACE,kBAAA;AAfJ;;AAmBA,4BAAA;AACA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAhBF;;AAmBA,0BAAA;AACA;EACE,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;AAhBF;;AAmBA,mBAAA;AACA;EACE,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AAhBF;;AAmBA,yBAAA;AACA;EACE,kBAAA;EACA,WAAA;AAhBF;;AAmBA,8BAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAhBF;AC5KE;EDuLF;IAQI,YAAA;EAfF;AACF;;AAkBA,6BAAA;AACA;EACE,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,yCAAA;EACA,qBAAA;EACA,qDAAA;AAhBF;AAkBE;EACE,UAAA;AAhBJ;AAmBE;EACE,uBAAA;AAjBJ;AAoBE;EACE,0CAAA;EACA,kBAAA;AAlBJ;;AAsBA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AAnBF;;AAsBA,mBAAA;AACA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAnBF;AAqBE;EACE,WAAA;EACA,yBAAA;AAnBJ;AAsBE;EACE,yBAAA;AApBJ;;AAwBA,mBAAA;AACA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AArBF;;AAwBA,uBAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;AArBF;AAuBE;EACE,YAAA;EACA,SAAA;AArBJ;;AAyBA,8BAAA;AACA;EACE,+BAAA;EACA,mBAAA;EACA,mBAAA;AAtBF;AAwBE;EACE,YAAA;EACA,uBAAA;EAEA,mCAAA;AAvBJ;AAwBI;EACE,oBAAA;EACA,YAAA;AAtBN;AAwBM;EACE,wCAAA;EACA,8CAAA;AAtBR;AA0BI;EACE,oCAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAxBN;;AA6BA,4BAAA;AACA;EACE,aAAA;EACA,cAAA;EACA,WAAA;EAsBA,6BAAA;AA/CF;ACtRE;ED4SF;IAMI,kBAAA;EAxBF;AACF;AA0BE;EATF;IAUI,aAAA;IACA,aAAA;EAvBF;AACF;AAyBE;EACE,iCAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;AAvBJ;AA0BE;EACE,WAAA;AAxBJ;AA4BE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,+DAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,qDAAA;EAEA,iBAAA;EAOA,0BAAA;EAMA,iBAAA;EAMA,kBAAA;EA2CA,qCAAA;AArFJ;AAwBI;EACE,2CAAA;EACA,mBAAA;EACA,2CAAA;AAtBN;AA0BI;EACE,2CAAA;EACA,mBAAA;AAxBN;AA4BI;EACE,2BAAA;EACA,4CAAA;AA1BN;AA8BI;EACE,0BAAA;AA5BN;AA+BI;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AA7BN;AAgCI;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AA9BN;AAgCM;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AA9BR;AAiCM;EACE,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,oCAAA;EACA,iBAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;AA/BR;AAoCI;EACE,WAAA;EACA,4CAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,iCAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EAEA,iBAAA;EAOA,iBAAA;EAKA,kBAAA;AA7CN;AAkCM;EACE,2CAAA;EACA,mBAAA;EACA,qCAAA;AAhCR;AAoCM;EACE,qCAAA;AAlCR;AAsCM;EACE,oCAAA;AApCR;AAwCI;EACE,iBAAA;EACA,cAAA;EACA,oCAAA;EACA,iCAAA;EACA,SAAA;AAtCN;;AA2CA,4BAAA;AACA;EACE,YAAA;AAxCF;AA0CE;EACE,cAAA;AAxCJ;;AA4CA,mBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,aAAA;EACA,iBAAA;EACA,yDAAA;EAEA,uBAAA;AA1CF;AA2CE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EAkCA,oBAAA;EA2BA,oBAAA;AApGJ;AAyCI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAvCN;AAyCM;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,SAAA;AAvCR;AA0CM;EACE,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,iCAAA;EACA,SAAA;AAxCR;AA4CI;EACE,WAAA;EACA,WAAA;EACA,gBAAA;AA1CN;AA8CI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AA5CN;AA8CM;EACE,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,SAAA;AA5CR;AA+CM;EACE,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,iCAAA;EACA,SAAA;AA7CR;AAkDI;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,sCAAA;EAEA,iBAAA;EAOA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;EAKA,mBAAA;AApEN;AA8CM;EACE,iDAAA;EACA,mBAAA;EACA,8CAAA;AA5CR;AAgDM;EACE,iDAAA;EACA,mBAAA;AA9CR;AAkDM;EACE,gDAAA;AAhDR;AAoDM;EACE,0BAAA;AAlDR;AAsDM;EACE,yBAAA;EACA,mBAAA;AApDR;AAsDQ;EACE,cAAA;AApDV;AAwDM;EACE,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAtDR;;AA4DA,uBAAA;AACA;EACE,eAAA;EACA,WAAA;EAQA,iBAAA;AAhEF;AA0DE;EACE,4CAAA;EACA,mBAAA;EACA,gBAAA;AAxDJ;AA4DE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAOA,iBAAA;EAQA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;AAhFJ;AAwDI;EACE,4BAAA;EACA,6BAAA;AAtDN;AA0DI;EACE,2CAAA;EAEA,oBAAA;EACA,8CAAA;AAzDN;AA6DI;EACE,2CAAA;EACA,oBAAA;AA3DN;AA+DI;EACE,gDAAA;AA7DN;AAiEI;EACE,+CAAA;AA/DN;AAkEI;EACE,UAAA;AAhEN;AAmEI;EACE,UAAA;EACA,aAAA;EACA,gBAAA;AAjEN;AAmEM;EACE,oCAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAjER;AAoEM;EACE,YAAA;EACA,eAAA;EACA,SAAA;AAlER;AAsEI;EACE,WAAA;EACA,YAAA;AApEN;;AAyEA,8BAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,0CAAA;EACA,wDAAA;EACA,kBAAA;EACA,0BAAA;EACA,yBAAA;EAOA,uBAAA;EAoBA,wBAAA;AA/FF;AAsEE;EACE,WAAA;EACA,YAAA;AApEJ;AAwEE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,8BAAA;AAtEJ;AAwEI;EACE,eAAA;EACA,iCAAA;EACA,gCAAA;EACA,SAAA;AAtEN;AAyEI;EACE,oCAAA;AAvEN;AA4EE;EACE,aAAA;EACA,mBAAA;AA1EJ;AA4EI;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,iBAAA;EAMA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;AAzFN;AAyEM;EACE,0CAAA;EACA,mBAAA;AAvER;AA2EM;EACE,0CAAA;EACA,mBAAA;AAzER;AA6EM;EACE,qCAAA;AA3ER;AA+EM;EACE,sBAAA;AA7ER;AAgFM;EACE,YAAA;EACA,WAAA;EACA,cAAA;AA9ER;;AAoFA,oCAAA;AACA;EACE,0BAAA;EAMA,qBAAA;EAcA,oBAAA;EAoBA,2BAAA;EAUA,kCAAA;EAcA,oBAAA;EAMA,2BAAA;AAjJF;AA4EE;EACE,qCAAA;EACA,8BAAA;AA1EJ;AA8EE;EACE,8BAAA;EACA,gBAAA;AA5EJ;AA8EI;EACE,YAAA;AA5EN;AA+EI;EACE,YAAA;AA7EN;AAkFE;EACE,2BAAA;EACA,gBAAA;AAhFJ;AAkFI;EACE,uBAAA;AAhFN;AAmFI;EACE,iBAAA;EACA,uBAAA;AAjFN;AAmFM;EACE,mBAAA;EACA,wBAAA;AAjFR;AAuFE;EACE,4BAAA;EACA,uBAAA;AArFJ;AAuFI;EACE,uBAAA;AArFN;AA0FE;EACE,uBAAA;AAxFJ;AA0FI;EACE,uBAAA;AAxFN;AA2FI;EACE,uBAAA;EACA,uBAAA;AAzFN;AA8FE;EACE,iBAAA;EACA,uBAAA;AA5FJ;AAgGE;EACE,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AA9FJ;;AAuGA;EACE,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AApGF;;AAuGA;EACE,eAAA;EACA,WAAA;EAcA,uDAAA;EAmHA,uCAAA;EAyCA,iCAAA;EA4EF,+BAAA;EA0BA,8BAAA;AA/WA;AAiGE;EACE,4CAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AA/FJ;AAkGI;EACE,6CAAA;AAhGN;AAqGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EAGA,aAAA;EAOA,8CAAA;EAcA,0CAAA;EASA,sDAAA;EAOA,iBAAA;EAOA,6BAAA;AA5IJ;AAkGI;EACE,4BAAA;EACA,6BAAA;AAhGN;AAoGI;EAGE,mCAAA;EACA,8BAAA;EAEA,+DACE;EAEF,sBAAA;EACA,WAAA;AAvGN;AA2GI;EAEE,4GACE;AA3GR;AAiHI;EACE,gDAAA;EACA,2BAAA;EACA,yCAAA;AA/GN;AAmHI;EACE,+CAAA;EACA,wBAAA;EACA,yBAAA;AAjHN;AAqHI;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAnHN;AAqHM;EAEE,sCAAA;EACA,8CAAA;AApHR;AAwHI;EACE,UAAA;EACA,oBAAA;AAtHN;AAyHI;EACE,UAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;AAvHN;AAyHM;EACE,oCAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAvHR;AA0HM;EACE,YAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;AAxHR;AA4HI;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,+BAAA;AA1HN;AA8HI;EAEE,yBAAA;AA7HN;AAkIE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,6DAAA;EACA,SAAA;AAhIJ;AAkII;EACE,WAAA;EACA,YAAA;EACA,+BAAA;EACA,cAAA;AAhIN;AAmII;EACE,OAAA;AAjIN;AAmIM;EACE,oCAAA;EACA,eAAA;EACA,iCAAA;EACA,iBAAA;EACA,gBAAA;AAjIR;AAoIM;EACE,oCAAA;EACA,eAAA;EACA,iCAAA;EACA,SAAA;EACA,gBAAA;AAlIR;AAsII;EACE,cAAA;AApIN;AAyIE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EAGA,aAAA;EAEA,4CAAA;AA1IJ;AA2II;EAEE,qDAAA;EACA,8BAAA;EACA,kDAAA;EACA,4DAAA;EACA,qBAAA;AA1IN;AA6II;EACE,kDAAA;EACA,sBAAA;AA3IN;AA8II;EACE,kDAAA;EACA,mBAAA;AA5IN;AA+II;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,oBAAA;AA7IN;AAiJI;EAEE,4BAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,2BAAA;AAhJN;AAsJA;EACE;IACE,UAAA;IACA,4CAAA;EApJF;EAsJA;IACE,UAAA;IACA,yCAAA;EApJF;AACF;AAwJA;EAEI;IAEE,oCAAA;IACA,8BAAA;IACA,yDACE;EAzJN;EA+JE;IAEE,iCAAA;IACA,6BAAA;EA9JJ;EAgKI;IACE,qBAAA;EA9JN;AACF;AAoKA;EACE;IACE,gBAAA;EAlKF;EAoKE;IACE,eAAA;EAlKJ;EAsKA;IACE,eAAA;IACA,gBAAA;EApKF;EAsKE;IACE,eAAA;EApKJ;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n/* Accessibility utilities */\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Main content styles */\nion-content {\n  padding: 0 10px;\n  --background: #F3F3F3 !important;\n}\n\n/* Header toolbar */\n.toolbar {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: 20px;\n  background: white;\n  align-items: center;\n  box-shadow: 0px -4px 15px 0px #4F614F40;\n\n  /* Accessible button reset */\n  .toolbar-button {\n    background: transparent;\n    border: none;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    border-radius: 50%;\n\n    /* Focus styles */\n    &:focus {\n      outline: 3px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n\n    /* Keyboard focus styles */\n    &:focus-visible {\n      outline: 3px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n\n    /* Hover styles */\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n\n    /* Active styles */\n    &:active {\n      transform: scale(0.95);\n    }\n\n    ion-icon {\n      font-size: 24px;\n      color: var(--ion-color-secondary);\n    }\n  }\n\n  .title {\n    margin: 0;\n    font-family: AppFontBold;\n    font-size: 25px;\n    line-height: 21px;\n    letter-spacing: 0em;\n    text-align: center;\n    color: #000;\n  }\n}\n\n/* Promo info banner */\n.promo-info {\n  align-items: center;\n  padding: 15px;\n  background: white;\n  margin: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  font-size: 14px;\n\n  .name {\n    width: 180px;\n  }\n\n  /* Improve visibility on focus */\n  &:focus-within {\n    box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);\n  }\n}\n\n/* Minimum order notice */\n.min-order {\n  margin: 10px;\n}\n\n/* Add more button */\n.add-more {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  height: 34px;\n  min-width: fit-content;\n  padding: 10px;\n  cursor: pointer;\n  border-radius: 22px;\n  background-color: var(--ion-color-primary);\n  border: none;\n  margin-top: 15px;\n\n  /* Focus styles */\n  &:focus {\n    outline: 3px solid white;\n    outline-offset: 2px;\n    box-shadow: 0 0 0 4px rgba(113, 167, 97, 0.4);\n  }\n\n  /* Keyboard focus styles */\n  &:focus-visible {\n    outline: 3px solid white;\n    outline-offset: 2px;\n  }\n\n  /* Hover state */\n  &:hover {\n    background-color: var(--ion-color-primary-shade);\n  }\n\n  /* Active state */\n  &:active {\n    transform: scale(0.98);\n  }\n\n  .add-text {\n    font-family: AppFontBold;\n    font-size: 11px;\n    line-height: 13px;\n    letter-spacing: 0px;\n    text-align: left;\n    color: white;\n  }\n\n  .add-button {\n    margin-right: 12px;\n  }\n}\n\n/* Empty cart presentation */\n.card-actions {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n/* Disabled button state */\n.footer-button.invalid, .footer-btn.invalid {\n  --background: darkgrey;\n  color: grey;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* Main container */\n.wrapper {\n  max-height: 100%;\n  flex-direction: column;\n  display: flex;\n  height: 100%;\n  background: #F3F3F3;\n  background-size: cover;\n}\n\n/* Order list container */\n.order-list {\n  margin-block: 12px;\n  width: 100%;\n}\n\n/* Article list presentation */\n.article {\n  text-align: center;\n  height: 110px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  @include mobile {\n    height: 35px;\n  }\n}\n\n/* Ordered articles section */\n.ordered-articles {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 17px 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: #F3F3F3;\n\n  /* Improved scrollbar for accessibility */\n  scrollbar-width: thin;\n  scrollbar-color: var(--ion-color-primary) transparent;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--ion-color-primary);\n    border-radius: 4px;\n  }\n}\n\n.ordered-articles-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 13px;\n}\n\n/* Separator line */\n.separator {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  .line {\n    height: 8px;\n    background-size: 7px 100%;\n  }\n\n  &--wide .line {\n    background-size: 8px 100%;\n  }\n}\n\n/* Error messages */\n.promo-error, .error-message {\n  margin: 10px;\n  font-size: 13px;\n  text-align: center;\n  color: #b02424;\n  font-weight: bold;\n}\n\n/* Empty cart message */\n.no-articles {\n  display: flex;\n  justify-content: center;\n  padding: 20px;\n\n  h3 {\n    color: black;\n    margin: 0;\n  }\n}\n\n/* Age verification checkbox */\n.age-verified {\n  color: var(--ion-color-primary);\n  margin-bottom: 10px;\n  background: #ffffff;\n\n  ion-item {\n    border: none;\n    align-items: flex-start;\n\n    /* Improve checkbox accessibility */\n    ion-checkbox {\n      --border-radius: 2px;\n      --size: 20px;\n\n      &:focus {\n        --border-color: var(--ion-color-primary);\n        box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);\n      }\n    }\n\n    label {\n      font-family: AppFontBold, sans-serif;\n      font-size: 14px;\n      cursor: pointer;\n      padding: 2px 0;\n    }\n  }\n}\n\n/* Recommendations section */\n.recommenation_section {\n  padding: 10px;\n  margin: 10px 0;\n  width: 100%;\n\n  @include mobile {\n    padding: 10px 20px;\n  }\n\n  @media (max-width: 400px) {\n    padding: 10px;\n    margin: 6px 0;\n  }\n\n  .recom_title {\n    color: var(--ion-color-secondary);\n    font-family: AppFontBold, sans-serif;\n    font-size: 14px;\n    margin-left: 10px;\n  }\n\n  .recommenation_section_articles {\n    width: 100%;\n  }\n\n  /* Recommendation item card */\n  .recommenation_section_articles__item {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    border-radius: 10px;\n    padding: 10px;\n    box-shadow: 0px 1.95px 7.3px 0px #4F614F26;\n    background: white;\n    width: 100%;\n    text-align: left;\n    border: none;\n    cursor: pointer;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n    /* Focus styles */\n    &:focus {\n      outline: 3px solid var(--ion-color-primary);\n      outline-offset: 2px;\n      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n    }\n\n    /* Keyboard focus styles */\n    &:focus-visible {\n      outline: 3px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n\n    /* Hover styles */\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.15);\n    }\n\n    /* Active styles */\n    &:active {\n      transform: translateY(1px);\n    }\n\n    img {\n      width: 120px;\n      height: 60px;\n      object-fit: contain;\n      max-width: 200px;\n      margin: 0 auto;\n    }\n\n    .item-details {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n\n      .left-section {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: flex-start;\n      }\n\n      .name {\n        color: var(--ion-color-secondary);\n        font-size: 13px;\n        text-align: center;\n        padding: 10px 5px;\n        font-family: AppFontBold, sans-serif;\n        margin-right: 5px;\n        word-break: break-word;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        height: 40px;\n        margin: 0;\n      }\n    }\n\n    /* Add button within recommendation */\n    .add_button {\n      width: 100%;\n      border: 1px solid var(--ion-color-secondary);\n      background: transparent;\n      padding: 8px;\n      border-radius: 10px;\n      color: var(--ion-color-secondary);\n      font-family: AppFontBold;\n      text-align: center;\n      display: flex;\n      justify-content: center;\n      margin-top: 10px;\n      cursor: pointer;\n\n      /* Focus styles */\n      &:focus {\n        outline: 2px solid var(--ion-color-primary);\n        outline-offset: 2px;\n        background-color: rgba(0, 0, 0, 0.05);\n      }\n\n      /* Hover styles */\n      &:hover {\n        background-color: rgba(0, 0, 0, 0.05);\n      }\n\n      /* Active styles */\n      &:active {\n        background-color: rgba(0, 0, 0, 0.1);\n      }\n    }\n\n    .price {\n      text-align: right;\n      padding: 5px 0;\n      font-family: AppFontBold, sans-serif;\n      color: var(--ion-color-secondary);\n      margin: 0;\n    }\n  }\n}\n\n/* Swiper container styles */\nswiper-container {\n  height: 100%;\n\n  swiper-slide {\n    margin: 0 10px;\n  }\n}\n\n/* Footer section */\n.footer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: stretch;\n  padding: 17px;\n  background: white;\n  box-shadow: 0px -3px 45px 0px #0000001A;\n\n  /* Price summary rows */\n  .button-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: column;\n\n    .sub-total {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      width: 100%;\n      margin-top: 19px;\n\n      .sub-total-title {\n        font-family: AppFont;\n        font-size: 14px;\n        letter-spacing: 0em;\n        text-align: left;\n        color: var(--ion-color-secondary);\n        margin: 0;\n      }\n\n      .sub-total-sum {\n        font-family: AppFontBold;\n        font-size: 14px;\n        letter-spacing: 0em;\n        text-align: right;\n        color: var(--ion-color-secondary);\n        margin: 0;\n      }\n    }\n\n    .border-line {\n      width: 100%;\n      height: 3px;\n      margin-top: 13px;\n    }\n\n    /* Total price row */\n    .total {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      width: 100%;\n      margin-top: 19px;\n\n      .total-title {\n        font-family: AppFontBold;\n        font-size: 18px;\n        letter-spacing: 0em;\n        text-align: left;\n        color: var(--ion-color-secondary);\n        margin: 0;\n      }\n\n      .total-sum {\n        font-family: AppFontBold;\n        font-size: 18px;\n        letter-spacing: 0em;\n        text-align: right;\n        color: var(--ion-color-secondary);\n        margin: 0;\n      }\n    }\n\n    /* Checkout button */\n    .footer-btn {\n      margin-top: 12px;\n      min-height: 46px;\n      height: 46px;\n      width: 100%;\n      position: relative;\n      padding: 5px;\n      background: var(--ion-color-primary);\n      color: white;\n      border: none;\n      border-radius: 4px;\n      cursor: pointer;\n      transition: background-color 0.2s ease;\n\n      /* Focus styles */\n      &:focus {\n        outline: 3px solid var(--ion-color-primary-shade);\n        outline-offset: 2px;\n        box-shadow: 0 0 0 4px rgba(113, 167, 97, 0.25);\n      }\n\n      /* Keyboard focus styles */\n      &:focus-visible {\n        outline: 3px solid var(--ion-color-primary-shade);\n        outline-offset: 2px;\n      }\n\n      /* Hover state */\n      &:hover:not(:disabled) {\n        background-color: var(--ion-color-primary-shade);\n      }\n\n      /* Active state */\n      &:active:not(:disabled) {\n        transform: translateY(1px);\n      }\n\n      /* Disabled state */\n      &:disabled, &.invalid {\n        background-color: #cccccc;\n        cursor: not-allowed;\n\n        .footer-btn-text {\n          color: #777777;\n        }\n      }\n\n      .footer-btn-text {\n        font-family: AppFontBold;\n        font-size: 16px;\n        line-height: 14px;\n        letter-spacing: 0em;\n        text-align: center;\n        color: #fff;\n        margin: 0;\n      }\n    }\n  }\n}\n\n/* Promo code section */\n.add-promo-section {\n  padding: 10px 0;\n  width: 100%;\n\n  .wrapper-promo {\n    border: 1.5px solid var(--ion-color-primary);\n    border-radius: 17px;\n    overflow: hidden;\n  }\n\n  /* Promo button */\n  .add-promo-block {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 20px;\n    background: var(--ion-color-primary);\n    color: white;\n    padding: 10px;\n    width: 100%;\n    border: none;\n    cursor: pointer;\n\n    &.border-bottom {\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n\n    /* Focus styles */\n    &:focus {\n      outline: 3px solid var(--ion-color-primary);\n\n      outline-offset: -2px;\n      box-shadow: 0 0 0 4px rgba(113, 167, 97, 0.25);\n    }\n\n    /* Keyboard focus styles */\n    &:focus-visible {\n      outline: 3px solid var(--ion-color-primary);\n      outline-offset: -2px;\n    }\n\n    /* Hover state */\n    &:hover {\n      background-color: var(--ion-color-primary-shade);\n    }\n\n    /* Active state */\n    &:active {\n      background-color: var(--ion-color-primary-tint);\n    }\n\n    ion-img {\n      width: 20%;\n    }\n\n    .block-text {\n      width: 70%;\n      padding: 10px;\n      text-align: left;\n\n      h3 {\n        font-family: AppFontBold, sans-serif;\n        color: white;\n        font-size: 20px;\n        margin: 0 0 5px 0;\n      }\n\n      p {\n        color: white;\n        font-size: 18px;\n        margin: 0;\n      }\n    }\n\n    .chevron {\n      width: 22px;\n      height: 22px;\n    }\n  }\n}\n\n/* Applied promocode display */\n.add-promocode-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: white;\n  border-radius: var(--custom-border-radius);\n  box-shadow: 0px 0px 42px 0px #00000012;\n  padding: 10px 15px;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n\n  ion-icon {\n    width: 22px;\n    height: 22px;\n  }\n\n  /* Promo code details */\n  .name-of-promo {\n    display: flex;\n    align-items: center;\n    min-width: 60%;\n    text-align: start;\n    justify-content: space-between;\n\n    h2, h3 {\n      font-size: 16px;\n      color: var(--ion-color-secondary);\n      font-family: AppFont, sans-serif;\n      margin: 0;\n    }\n\n    h3 {\n      font-family: AppFontBold, sans-serif;\n    }\n  }\n\n  /* Remove promo button */\n  .edit_section {\n    display: flex;\n    align-items: center;\n\n    .bsg-remove-promo {\n      background: transparent;\n      border: none;\n      padding: 8px;\n      border-radius: 50%;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      /* Focus styles */\n      &:focus {\n        border: 2px solid var(--ion-color-primary);\n        outline-offset: 2px;\n      }\n\n      /* Keyboard focus styles */\n      &:focus-visible {\n        border: 2px solid var(--ion-color-primary);\n        outline-offset: 2px;\n      }\n\n      /* Hover state */\n      &:hover {\n        background-color: rgba(0, 0, 0, 0.05);\n      }\n\n      /* Active state */\n      &:active {\n        transform: scale(0.95);\n      }\n\n      ion-icon {\n        height: 30px;\n        width: 30px;\n        color: #b02424;\n      }\n    }\n  }\n}\n\n/* High contrast mode enhancements */\n.bsg-high-contrast {\n  /* Enhanced button focus */\n  button:focus {\n    outline: 3px solid #0078d7 !important;\n    outline-offset: 2px !important;\n  }\n\n  /* Enhanced toolbar */\n  .toolbar {\n    border-bottom: 2px solid black;\n    box-shadow: none;\n\n    .toolbar-button ion-icon {\n      color: black;\n    }\n\n    .title {\n      color: black;\n    }\n  }\n\n  /* Enhanced footer */\n  .footer {\n    border-top: 2px solid black;\n    box-shadow: none;\n\n    .sub-total-title, .sub-total-sum, .total-title, .total-sum {\n      color: black !important;\n    }\n\n    .footer-btn {\n      background: black;\n      border: 2px solid white;\n\n      &:disabled, &.invalid {\n        background: #555555;\n        border: 2px dashed black;\n      }\n    }\n  }\n\n  /* Enhanced promo section */\n  .add-promo-block {\n    background: black !important;\n    border: 2px solid white;\n\n    .block-text h3, .block-text p {\n      color: white !important;\n    }\n  }\n\n  /* Enhanced recommendation items */\n  .recommenation_section_articles__item {\n    border: 2px solid black;\n\n    .name, .price {\n      color: black !important;\n    }\n\n    .add_button {\n      border: 2px solid black;\n      color: black !important;\n    }\n  }\n\n  /* Add more button */\n  .add-more {\n    background: black;\n    border: 2px solid white;\n  }\n\n  /* Enhanced error message */\n  .error-message {\n    color: black !important;\n    background: #ffcccc;\n    border: 1px solid black;\n    padding: 5px;\n  }\n}\n\n\n\n\n\n// Utility class for screen readers\n.visually-hidden {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.add-promo-section {\n  padding: 10px 0;\n  width: 100%;\n\n  .wrapper-promo {\n    border: 1.5px solid var(--ion-color-primary);\n    border-radius: 17px;\n    overflow: hidden;\n    position: relative;\n\n    // Enhanced wrapper focus-within state\n    &:focus-within {\n      box-shadow: 0 0 0 3px rgba(56, 128, 255, 0.3);\n    }\n  }\n\n  /* Enhanced Promo button with better focus visibility */\n  .add-promo-block {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 16px;\n    background: var(--ion-color-primary);\n    color: white;\n    padding: 10px;\n    width: 100%;\n    border: none;\n    cursor: pointer;\n    position: relative;\n    transition: all 0.2s ease;\n\n    // Remove default button outline\n    outline: none;\n\n    &.border-bottom {\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n\n    /* ENHANCED FOCUS STYLES - Much more visible */\n    &:focus,\n    &:focus-visible {\n      // White outline that contrasts with primary color background\n      outline: 3px solid white !important;\n      outline-offset: 2px !important;\n      // Additional box shadow for extra visibility\n      box-shadow:\n        0 0 0 6px var(--ion-color-primary-shade) !important;\n      // Slight scale for attention\n      transform: scale(1.02);\n      z-index: 10;\n    }\n\n    /* Alternative high-contrast focus style */\n    &:focus-visible {\n      // Double outline effect\n      box-shadow:\n        inset 0 0 0 2px white,\n        0 0 0 4px var(--ion-color-warning, #ffc409),\n        0 4px 8px rgba(0, 0, 0, 0.2);\n    }\n\n    /* Hover state - make sure it's different from focus */\n    &:hover:not(:focus) {\n      background-color: var(--ion-color-primary-shade);\n      transform: translateY(-1px);\n      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n    }\n\n    /* Active state */\n    &:active {\n      background-color: var(--ion-color-primary-tint);\n      transform: translateY(0);\n      transition: all 0.1s ease;\n    }\n\n    /* Disabled state if needed */\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n      transform: none;\n\n      &:focus,\n      &:focus-visible {\n        outline-color: var(--ion-color-medium);\n        box-shadow: 0 0 0 3px rgba(150, 150, 150, 0.5);\n      }\n    }\n\n    ion-img {\n      width: 20%;\n      pointer-events: none; // Prevent image from interfering with button clicks\n    }\n\n    .block-text {\n      width: 70%;\n      padding: 10px;\n      text-align: left;\n      pointer-events: none; // Prevent text from interfering with button clicks\n\n      h3 {\n        font-family: AppFontBold, sans-serif;\n        color: white;\n        font-size: 22px;\n        margin: 0 0 5px 0;\n        line-height: 1.2;\n      }\n\n      p {\n        color: white;\n        font-size: 18px;\n        margin: 0;\n        line-height: 1.3;\n        opacity: 0.9;\n      }\n    }\n\n    .chevron {\n      width: 22px;\n      height: 22px;\n      pointer-events: none;\n      transition: transform 0.2s ease;\n    }\n\n    // Rotate chevron when focused for visual feedback\n    &:focus .chevron,\n    &:focus-visible .chevron {\n      transform: rotate(180deg);\n    }\n  }\n\n  /* Applied promo code section styling */\n  .add-promocode-wrapper {\n    display: flex;\n    align-items: center;\n    padding: 12px;\n    background: white;\n    border-top: 1px solid rgba(var(--ion-color-primary-rgb), 0.2);\n    gap: 12px;\n\n    .submit-button {\n      width: 24px;\n      height: 24px;\n      color: var(--ion-color-success);\n      flex-shrink: 0;\n    }\n\n    .name-of-promo {\n      flex: 1;\n\n      .name {\n        font-family: AppFontBold, sans-serif;\n        font-size: 14px;\n        color: var(--ion-color-secondary);\n        margin: 0 0 2px 0;\n        line-height: 1.2;\n      }\n\n      .discount {\n        font-family: AppFontBold, sans-serif;\n        font-size: 13px;\n        color: var(--ion-color-secondary);\n        margin: 0;\n        line-height: 1.2;\n      }\n    }\n\n    .edit_section {\n      flex-shrink: 0;\n    }\n  }\n\n  /* Enhanced remove promo button */\n  .edit-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 8px;\n    border-radius: 50%;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n\n    // Remove default outline\n    outline: none;\n\n    /* ENHANCED FOCUS STYLES for remove button */\n    &:focus,\n    &:focus-visible {\n      outline: 2px solid var(--ion-color-danger) !important;\n      outline-offset: 2px !important;\n      background: rgba(var(--ion-color-danger-rgb), 0.1);\n      box-shadow: 0 0 0 4px rgba(var(--ion-color-danger-rgb), 0.2);\n      transform: scale(1.1);\n    }\n\n    &:hover:not(:focus) {\n      background: rgba(var(--ion-color-danger-rgb), 0.1);\n      transform: scale(1.05);\n    }\n\n    &:active {\n      background: rgba(var(--ion-color-danger-rgb), 0.2);\n      transform: scale(1);\n    }\n\n    ion-icon {\n      width: 20px;\n      height: 20px;\n      color: var(--ion-color-danger);\n      pointer-events: none;\n    }\n\n    // Tooltip on focus\n    &:focus::after,\n    &:focus-visible::after {\n      content: 'Remove promo code';\n      position: absolute;\n      top: -35px;\n      left: 50%;\n      transform: translateX(-50%);\n      background: var(--ion-color-dark);\n      color: white;\n      padding: 4px 8px;\n      border-radius: 4px;\n      font-size: 12px;\n      white-space: nowrap;\n      z-index: 100;\n      opacity: 1;\n      animation: fadeIn 0.2s ease;\n    }\n  }\n\n\n// Fade in animation for tooltip\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  .add-promo-block {\n    &:focus,\n    &:focus-visible {\n      outline: 4px solid yellow !important;\n      outline-offset: 2px !important;\n      box-shadow:\n        0 0 0 8px black,\n        0 0 0 12px yellow !important;\n    }\n  }\n\n  .edit-btn {\n    &:focus,\n    &:focus-visible {\n      outline: 3px solid red !important;\n      background: yellow !important;\n\n      ion-icon {\n        color: red !important;\n      }\n    }\n  }\n}\n\n/* Mobile touch improvements */\n@media (max-width: 768px) {\n  .add-promo-block {\n    min-height: 48px; // Minimum touch target\n\n    &:hover {\n      transform: none; // Disable hover transform on mobile\n    }\n  }\n\n  .edit-btn {\n    min-width: 44px;\n    min-height: 44px;\n\n    &:hover {\n      transform: none;\n    }\n  }\n}\n\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
